import BenchmarkHarvestChart from './BenchmarkHarvestChart';

export default BenchmarkHarvestChart;
